import React, { useState, useEffect } from 'react';
import './password-strength.css';

export const PasswordInput = ({ 
    name = "password",
    placeholder = "Contraseña",
    value = "",
    onChange,
    showGenerator = false,
    onPasswordGenerate
}) => {
    const [showPassword, setShowPassword] = useState(false);
    const [strength, setStrength] = useState(0);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const calculatePasswordStrength = (password) => {
        if (!password) return 0;
        
        let score = 0;
        const checks = {
            length: password.length >= 8,
            lowercase: /[a-z]/.test(password),
            uppercase: /[A-Z]/.test(password),
            numbers: /\d/.test(password),
            special: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)
        };

        // Calcular puntuación
        if (checks.length) score++;
        if (checks.lowercase) score++;
        if (checks.uppercase) score++;
        if (checks.numbers) score++;
        if (checks.special) score++;

        return score;
    };

    useEffect(() => {
        const newStrength = calculatePasswordStrength(value);
        setStrength(newStrength);
    }, [value]);

    const getStrengthClass = (index) => {
        if (strength === 0) return '';
        if (strength === 1) return index === 0 ? 'weak' : '';
        if (strength === 2) return index <= 1 ? 'fair' : '';
        if (strength === 3) return index <= 2 ? 'good' : '';
        if (strength === 4) return index <= 3 ? 'strong' : '';
        if (strength === 5) return index <= 4 ? 'very-strong' : '';
        return '';
    };

    return (
        <div className="generate-pass">
            <div className="input-group field">
                <input
                    type={showPassword ? "text" : "password"}
                    className="form-control password"
                    name={name}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    required
                />
                {showGenerator && onPasswordGenerate && (
                    <div 
                        className="input-group-text c-pointer gen-pass" 
                        data-bs-toggle="tooltip" 
                        title="Generar contraseña segura"
                        onClick={onPasswordGenerate}
                    >
                        <i className="feather-hash"></i>
                    </div>
                )}
                <div 
                    className="input-group-text border-start bg-gray-2 c-pointer show-pass" 
                    data-bs-toggle="tooltip" 
                    title={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                    onClick={togglePasswordVisibility}
                >
                    <i className={showPassword ? "feather-eye-off" : "feather-eye"}></i>
                </div>
            </div>
            {showGenerator && (
                <div className="progress-bar mt-2">
                    <div className={getStrengthClass(0)}></div>
                    <div className={getStrengthClass(1)}></div>
                    <div className={getStrengthClass(2)}></div>
                    <div className={getStrengthClass(3)}></div>
                    <div className={getStrengthClass(4)}></div>
                </div>
            )}
        </div>
    );
};
